import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Card, Col, Button } from "react-bootstrap";
import "../App.css";

const clickableNsCodes = [
  "NS072",
  "NS-055-12IW",
  "NS-10C",
  "NS-083",
  "NS-18-2",
  "NS-S-083",
  "NS-PA111",
  "NS-38F-12TS",
  "NS-MP",
  "NS-952-8IW",
];

const ProductCard = ({ item }) => {
  const location = useLocation();
  return (
    <Col xs={12} sm={6} md={4} lg={3} className="mt-3 mb-5">
      <Card className="h-100 shadow">
        <Card.Img
          variant="top"
          src={item.image}
          alt={item.description}
          style={{ height: "35vh", objectFit: "contain" }}
          className="product-card-img"
        />
        <Card.Body className="d-flex flex-column">
          <Card.Title style={{ fontFamily: "Poiret One", fontWeight: "bold" }}>
            {item.description}
          </Card.Title>
          <Card.Text className="flex-grow-1 mb-5">
            <strong>Unit Size: </strong> {item.us} <br />
            <strong>Case Size:</strong> {item.uom} <br />
            <strong>Weight:</strong> {item.pkgSize} <br />
            <strong>NSN:</strong> {item.stockNumber} <br />
            <strong>Vendor Code:</strong> {item.vendorPartNumber}
            {clickableNsCodes.includes(item.vendorPartNumber) &&
              location.pathname !== `/ns/${item.vendorPartNumber}` && (
                <>
                  <br />
                  <Button
                    as={Link}
                    to={`/ns/${item.vendorPartNumber}`}
                    variant="primary"
                    size="sm"
                    className="mt-2"
                  >
                    View {item.vendorPartNumber} Assortment
                  </Button>
                </>
              )}
          </Card.Text>
        </Card.Body>
      </Card>
    </Col>
  );
};

export default ProductCard;
